<template>
  <div class="workerorderindex">
    <top></top>
    <div class="nav">
      <router-link style="color:rgb(31, 55, 61);"  :to="urlb">
          <span  @click="hisback">首页</span>
      </router-link>
      <span class="navbread">{{'>'+questionclass}}</span>
      <a class="btna color" href="#/myorder" :style="{backgroundColor:boxBodyColor}">我的工单</a>
    </div>
    <div class="content">
      <div>
        <span class="label">工单编号:</span>
        <span>{{processInstanceId}}</span>
      </div>
      <div v-show='inforis'>
        <span class="label">补填信息:</span>
        <span>请您点击【补填信息】按钮进行单据填补</span>
        <el-button class="color btn" size="small" type="primary" @click="commitgo" :style="{backgroundColor:boxBodyColor}">补填信息</el-button>
      </div>
      <div v-if="staris==1">
         <span class="label">服务评价:</span>
         <span style="color:#999">请您对本次的服务做出评价</span>
         <div class="service">
            <p v-for="(item, index) in srcurl" @click="service(index)">
              <img :src='item.url' />
              <span :id="'service'+index">{{item.content}}</span>
            </p>
            <aside class="pingjia" v-show="pingjiais">
                <ul>
                  <span>处理结果:</span>
                  <span v-for="(item,index) in result" @click="star('result',index)">
                    <img :src="'/pc/static/assets/im_star_'+item+'.png'">
                  </span>
                </ul>
                 <ul>
                  <span>服务态度:</span>
                  <span v-for="(item,index) in autitude" @click="star('autitude',index)">
                    <img :src="'/pc/static/assets/im_star_'+item+'.png'">
                  </span>
                </ul>
                 <ul>
                  <span>处理时长:</span>
                  <span v-for="(item,index) in time" @click="star('time',index)">
                    <img :src="'/pc/static/assets/im_star_'+item+'.png'">
                  </span>
                </ul>
                <ul style="height:180px;">
                  <span style="margin-left:30px;">说明:</span>
                  <textarea v-model="commpent" placeholder="您的建议就是我们奋斗的目标"  class="explain"></textarea>
                </ul>
           </aside>
           <span style="clear:both;display:block"></span>
           <el-button class="color submit" size="small" type="primary" @click="starcommit" :style="{backgroundColor:boxBodyColor}">提交</el-button>
         </div>
      </div>
      <div v-else-if="staris==2">
        <span class="label">服务评价:</span>
         <span style="color:#ff864a">感谢您对本次的服务做出评价</span>
      </div>
      <div class="detail">
        <span class="label">处理进度:</span>
        <div class="detailright">
          <div v-for="(item ,index) in detail" class="detailcontent">
            <span v-if="index==0" class="orangepot"></span>
            <span v-else class="pot"></span>
            <p class="date">{{item.date}}</p>
            <p v-if="index!=0"  class="content">{{item.title}}</p>
            <p v-else  class="contenting">{{item.title}}</p>

            <p v-if="index!=0"  class="content" v-dompurify-html="item.content"></p>
            <p v-else  class="contenting" v-dompurify-html="item.content"></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as Urls from '../url.js'
import top from '../workorder/top.vue'
import axios from '@/utils/request.js'
export default {
  name: 'workdetail',
  components: {
    top
  },
  data () {
    return {
      urlb:'',
      commpent:"",
      ping:false,
      basurl:Urls.baseurl,
      md5:"",
      kefuis:false,
      processInstanceId:'',
      pingjiais:false,
      inforis:false,
      staris:3,
      mode:1,
      times:0,
      starindex:0,
      orderid:'',
      fromid:'',
      questionclass:"单据处理详情",
      detail:[{"date":"2017-02-05 14:30","title":"正在受理","content":""},{"date":"2017-02-05 14:30","title":"提交成功","content":""}], // 默认数据 不要随便修改
      srcurl:[{"content":"满意","url":"/pc/static/assets/im_star1_dark.png"},{"content":"一般","url":"/pc/static/assets/im_star2_dark.png"},{"content":"不满意","url":"/pc/static/assets/im_star3_dark.png"}],
      result:['bright','bright','bright','bright','bright'],
      autitude:['bright','bright','bright','bright','bright'],
      time:['bright','bright','bright','bright','bright'],
      resultindex:4,
      autitudeindex:4,
      timeidnex:4,
      inforlength:false,
      boxBodyColor:'',
      logoUrl:'',
      companyName:'',
      displayMode:''
    }
  },
  mounted(){
      var vm=this;
      vm.boxBodyColor = sessionStorage.getItem('boxBodyColor')
      vm.companyName = sessionStorage.getItem('companyName')
      vm.logoUrl = sessionStorage.getItem('logoUrl');
      vm.displayMode = sessionStorage.getItem('displayMode')
      this.md5=sessionStorage.getItem("md5");
      this.processInstanceId=location.href.split("?id=")[1];
      axios.get(this.basurl+'/api/visitor/wo/workOrderDetail/'+this.processInstanceId+'?visitorMd5Code='+this.md5).then(function(response){
        //console.log(response)
         if(response.data.code==1){
            var obj=response.data.data;
            vm.orderid=obj.orderInfo.orderId;
            vm.fromid=obj.orderInfo.formId;
            if(obj.orderInfo.replenishStatus==1){
              vm.inforis=true;
            }else{
              vm.inforis=false;
            }
            vm.describeTime(obj.orderInfo.startTime)
            if(obj.tasklist.length!=0){
              vm.describe(obj.tasklist)
            }

         }
       });
      var indexurl=sessionStorage.getItem("indexUrl");
      if (indexurl == 'workerorderindex') {
        vm.urlb="workerorderindex"
      }
      //判断客服是否显示
       axios.get(this.basurl+'/api/visitor/product/conf/showOnlineService?visitorMd5Code='+this.md5).then(function(response){
          if(response.data.code==1){
            vm.kefuis=true;
          }
       });


  },
  methods:{
    //判断跳转页面
    kefugo(){
        var vm=this;
        axios.get(this.basurl+'/api/visitor/product/conf/redirectToOnlineService?visitorMd5Code='+this.md5).then(function(response){
          //console.log(response)

          if(response.data.code==1){
            var obj=response.data.data;

            if(obj.imStatus=="waiting"){
              vm.$router.replace({path: 'imLineUp'});
              //window.location.href="#/imLineUp";

            }else if(obj.imStatus=="chatting"){
                vm.$router.replace({path: 'imSession'});
               //window.location.href="#/imSession";
            }else{
                if(obj.target==1){
                  //window.location.href="#/spirit";
                  vm.$router.replace({path: 'spirit'});
                  console.log('已经跳转了');
                }
                if(obj.target==2){
                  vm.$router.replace({path: 'imDirectory'});
                  //window.location.href="#/imDirectory";
                }
            }
          }
        })
    },
    commitgo(){
      var obj={};
      obj.orderid=this.orderid;
      obj.processInstanceId=this.processInstanceId;
      obj.fromid=this.fromid
      sessionStorage.setItem('butianinfor',JSON.stringify(obj));
      window.location.href="#/commitinfor?butianinfor"
    },
    starcommit(){
      if(this.ping==true ){
          var obj={};

        obj.mode =this.mode;
        obj.sessionId = this.processInstanceId;
        //obj.basicLevel=this.starindex+1;
        if(this.starindex==0){
          obj.basicLevel=3
        }else if(this.starindex==1){
          obj.basicLevel=2;
        }else if(this.starindex==2){
          obj.basicLevel=1;
        }
        if(this.mode==2){
          obj.processAttitudeScore=this.autitudeindex+1;
          obj.processDurationScore =this.timeidnex+1;
          obj.processResultScore =this.resultindex+1;
        }else{
          obj.processAttitudeScore=0;
          obj.processDurationScore =0;
          obj.processResultScore =0;
        }
        if(this.starindex!=0){
          if (this.commpent.length>50 ) {
            this.inforlength=false
            this.$message.error('说明最多为50个字符');
          }else{
            this.inforlength=true;
            obj.comment=this.commpent;
          }
        }else{
           this.inforlength=true;
        }

        console.log(obj)
        var vm=this;
        if(this.inforlength==true){
          axios.post(this.basurl+'/api/visitor/wo/evaluate?visitorMd5Code='+this.md5,obj).then(function(response){
          console.log(response)
            if(response.data.code==1){
                  vm.staris=2;
                  // vm.$alert( '感谢您的评价~~','上传成功', {confirmButtonText: '确定'})
            }else if(response.data.code==400){
              vm.$message.error('说明最多50个字符');
            }
         })
        }

      }

      if(this.ping==false){
        this.$message({
          message: '请对我们的服务做出评价哟！',
          type: 'warning'
        });
      }


    },
    service(index){
      this.ping=true;
      this.starindex=index;
      //console.log(this.starindex);
      this.srcurl.forEach( function(item, i) {
        if(item.url.indexOf("bright")>-1){
          item.url=item.url.replace("bright","dark");
        }
        var spanid=document.getElementById('service'+i)
        spanid.style.color = '#cccccc';
      });
       this.srcurl[index].url=this.srcurl[index].url.replace("dark","bright");
       var sid=document.getElementById('service'+index);
        sid.style.color = '#52db91';
        if(index >0 && this.mode==2){
          this.pingjiais=true;
        }else{
          this.pingjiais=false;
        }
    },
    star(cls,index){
        let vm = this
        if(cls=="result"){
          this.resultindex=index;
        }
        if(cls=="autitude"){
          this.autitudeindex=index;
        }
        if(cls=="time"){
          this.timeidnex=index;
        }

         this.result.forEach( function(item, i) {
           vm.$set(vm[cls],i,"dark")
        });
        for(var j=0;j<=index;j++){
          this.$set(this[cls],j,"bright")
        }

    },
    // 重置默认步骤的时间为当前单据生成时间
    describeTime(time){
      var vm=this
      vm.detail.forEach( function(element, index) {
        element.date=time;
      });
    },
    describe(arr){
      var vm=this
      var l=arr.length;
      var star=false;
      for(var i=l-1;i>=0;i--){
         var obj={};
         var element=arr[i]
         obj.content=element.comments;
         obj.date=element.startTime;
         if(element.type=="AddCommentReply"){
            obj.title="受理中"
         }
         if(element.type=="AddCommentNext"){
            obj.title="下一步"
         }
         if(element.type=="AddCommentReplyEnd"){
            obj.title="受理完成"
            star=true;
         };
         if(element.type=="AddCommentReply" || element.type=="AddCommentNext" || element.type=="AddCommentReplyEnd" ){
           vm.detail.unshift(obj)
         }

      }
      if(star==true){
        this.stargo()
      }


    },
    stargo(){
      var vm=this;
       axios.get(this.basurl+'/api/visitor/wo/evaluateInfo/'+this.processInstanceId+'?visitorMd5Code='+this.md5).then(function(response){
          //console.log(response)
          if(response.data.code==1){
             vm.mode=response.data.data.mode;
             //console.log(vm.mode)
             vm.times=response.data.data.times;
             if(vm.times==0){
              vm.staris=1;
             }else{
               vm.staris=2;
             }
          }
       })
    },
     hisback(){
      var vm=this;
      var indexurl=sessionStorage.getItem("indexUrl");
      var imEntranceMode=sessionStorage.getItem("imEntranceMode")
      console.log(indexurl)
      if (indexurl == 'aiInteractive') {
        window.location.href = "#/aiInteractive?v="+this.md5
         vm.urlb="aiInteractive?v="+this.md5
      } else if (indexurl == 'workerorderindex') {
        window.location.href = "#/workerorderindex"
         vm.urlb="workerorderindex"
      } else {
         axios.get(this.basurl+'/api/visitor/im/sessionStatus?visitorMd5Code='+this.md5).then(function(response){
            console.log(response);
            let imStatus = '';
            if(response.data.code==1){
              imStatus=response.data.data.status;
            }
              console.log(imStatus)
                if ((imStatus === 'ended' || !imStatus || imStatus === '') && indexurl == 'spirit') {
                  vm.urlb="spirit"
                  window.location.href="#/spirit"

                  return
                } else if (imStatus === 'waiting') {
                  vm.urlb="imLineUp"
                  window.location.href="#/imLineUp"

                  return
                } else if (imStatus === 'chatting') {
                  vm.urlb="imSession"
                  window.location.href="#/imSession"

                  return
                } else {
                  if (imEntranceMode === 1) {
                      vm.urlb="imLineUp"
                     window.location.href="#/imLineUp"
                  } else if (imEntranceMode === 2) {
                      vm.urlb="imDirectory"
                      window.location.href="#/imDirectory"

                  }
               }

            console.log(vm.urlb)
          })
      }
    }
  }
}
</script>

<style scoped>
 .top .title_img{
  display: inline-block;
  float: left;
  height: 35px;
  width: auto;
  margin: 5px 0 5px 20px;
}
.top .title_2{
  color:#fff;
  display: inline-block;
  float: left;
  margin-left:20px;
}
.top .title_2 span{
  font-size: 16px
}
   .content .explain{
    width: 240px;
    height: 140px;
    resize: none;
    margin-left: 4px;
    border-radius: 6px;
    padding: 10px;
    color: #333333;
    border-color:#cccccc;
   }
   .content .explain:focus{
    border-color:#cccccc;
   }
   .submit{
    display: block;
    clear: both;
    width: 80px;
    height: 24px;
    margin-top: 10px;
    margin-left: 70px;
   }
   .pingjia{
    display: block;
    clear: both;
    margin-left:10px;
    overflow: hidden;
   }
   .pingjia ul{
    clear: both;
    height: 20px;
    margin-top: 10px;
   }
   .pingjia span {
    color: #999999;
    margin-left: 5px;
    display: block;
    float: left;
   }
  .content{
    width: 460px;
    overflow: hidden;
    margin:0 auto;
  }
 .content div{
  width: 100%;
  font-size: 14px;
  padding: 20px 10px;
  color: #333333;
  border-bottom: 1px solid #cccccc;
 }
   .content .service{
    margin-left:80px;
    margin-top: 20px;
    border:0;
    overflow: hidden;
    padding: 0;
  }
  .content .service p{
    width: 46px;
    margin-left:20px;
    cursor: pointer;
    text-align: center;
    float: left;
    color: #999;
  }
  .content .service img{
    margin: 0 auto;
    display: block;
  }
 .content .detail{

  border:none;
 }
 .detail .label{
  float: left;
  display: block;
 }
 .detail .detailright{
  float: left;
  padding: 0;
  border-bottom: 0;
  border-left:1px solid #cccccc;
  margin-bottom: 30px;
  width: 355px;
 }
.detail .detailright .detailcontent{
  position: relative;
  width: 300px;
  padding:0;
  margin: 0;
  margin-left: 30px;
}
.detail .detailright .detailcontent .pot{
  display: block;
  position: absolute;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #99a0a6;
  left: -33px;
  top: 32px;
}
.detail .detailright .detailcontent .orangepot{
  display: block;
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #ff864a;
  left: -35px;
  top: 32px;
}
.detail .detailright .detailcontent .date{
  font-size: 12px;
  color: #999999;
  margin-top:4px;
}
.detail .detailright .detailcontent .content{
  font-size: 14px;
  color: #999999;
  line-height: 24px;
  margin-bottom: 10px;
  margin-top: 10px;
  max-width: 300px;
}
.detail .detailright .detailcontent .contenting{
  font-size: 14px;
  color: #333333;
  line-height: 24px;
  margin-bottom: 10px;
  margin-top: 10px;
  max-width: 300px;
}
 .label{
  margin-right: 20px;
  color: #666666;
 }
 .btn {
  display: block;
  margin-left: 100px;
  margin-top: 10px;
 }
 .workerorderindex{
  background: #f8f8f8;
  width: 100%;
  height: 100%;
 }
 .color{
  background: #009688;
 }
 .top{
   height: 46px;
   width: 100%;
 }
 .logo{
  margin-left: 20px;
  width: 140px;
  height: 34px;
  margin-top: 6px;
 }
 .top img,.top span{
  display: block;
  float: right;
  color: #fff;
  font-size:14px;
  cursor: pointer;
 }
 .top span{
  line-height: 46px;
  margin-left: 10px;
 }
 .kefu{
  position: absolute;
  right: 86px;
  margin-top: 11px;
 }
 .nav{
  width: 560px;
  margin:0 auto;
  height: 45px;
  border-bottom: 1px solid #000;
  font-size: 14px;
 }
 .nav span{
  line-height: 45px;
  color: #5987c2;
   font-weight:bold;
  text-decoration: underline;
 }
  .nav .btna{
    display: block;
    color: white;
    font-size: 14px;
    width: 70px;
    height: 24px;
    float: right;
    border-radius: 4px;
    text-align:center;
    line-height: 24px;
    margin-top: 11px;
  }
  .nav .navbread{
    text-decoration: none;
    color: #000;
    font-weight:bold;
  }

</style>



// WEBPACK FOOTER //
// src/components/workorder/workdetail.vue?42654302